import { observer } from "mobx-react-lite";
import { Modal } from "../index";

import EditBalanceModalContent from "../../../../pages/cashiers/cashiers-list/edit-balance-modal-content";
import { useTranslation } from "../../../../../hooks";
import { T } from "../../../../../constants"

interface BalanceOperationModalProps {
  id: number;
  onClose: () => void;
  currencyCode: string;
  currentBalance: number;
  openWithHeader: boolean;
}

export const BalanceOperationModal: React.FC<BalanceOperationModalProps>  = observer(({
   id,
   onClose,
   currencyCode,
   currentBalance,
   openWithHeader,
}) => {

  const t = useTranslation();

  return (
    <Modal
      onClose={onClose}
      title={t(T.EDIT_BALANCE)}
      closeOnOutsideClick={false}
    >
      <EditBalanceModalContent
        id={id}
        onClose={onClose}
        openWithHeader={openWithHeader}
        currentBalance={currentBalance}
        currencyCode={currencyCode}
      />
    </Modal>
  );
})